<template>

  <div :style="mapStyle">
    <v-progress-linear v-show="mapIsLoading"
      indeterminate
    ></v-progress-linear>
    <l-map
      v-if="show"
      ref="map"
      :key="'map'+invalidateCounter"
      :zoom="zoom"
      :center="center"
      :max-bounds="maxBoundEnabled?maxBounds:null"
      :options="mapOptions"
      style="height: 100%;"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
      @click="addMarker"
    >
      <l-control-layers v-if="showLayerSelector"/>
      <l-tile-layer
        v-for="layer in tileLayers"
        :key="layer.name"
        :url="layer.url"
        :attribution="attribution"
        :name="layer.name"
        :visible="layer.visible"
        :detectRetina="false"
        layer-type="base"
      />

      <!-- Listed companies -->
      <v-marker-cluster :options="{disableClusteringAtZoom:14,singleMarkerMode:singleMarkerMode,showCoverageOnHover: false,iconCreateFunction:clusterImg,polygonOptions:{ weight: 0.5, color: '#222', opacity: 0.5 }}">
      <l-marker  v-for="(item,index) in items" @click="onClickMarker(index)" :key="index"  :lat-lng="getPosByItem(item)" :icon="getIconByItem(item)" >
        <l-popup v-if="item && item.properties" :style="popupStyle">
          <div >
            <span v-if="null!=item.properties.title && ''!=item.properties.title">
              <b>{{item.properties.title}}</b>
              <a v-if="item.properties.url" target="_blank" :href="getValidUrl(item.properties.url)" class="pl-2 no-underline"><v-icon color="orange">mdi-open-in-new</v-icon></a>
            </span>
            <p v-if="null!=item.properties.image && ''!=item.properties.image">
              <center><a :href="getImageUrl(item.properties,item.properties.w,item.properties.h)" target="_blank"><v-img  contain alt="Image" min-width="200px" min-height="200px" :max-height="(isSmAndUpDevice)?'300px':'200px'" :src="getImageUrl(item.properties,item.properties.w,item.properties.h)"  style=""></v-img></a></center>
            </p>

            <p v-if="null!=item.properties.description && ''!=item.properties.description" v-html="item.properties.description">
            </p>

            <p v-if="show_more_link && item.properties.url" class="text-center">
              <a target="_blank" :href="getValidUrl(item.properties.url)" class="orange--text text--darken-3">>> {{$t('read_more_about_project')}} >> </a>
            </p>
          </div>
        </l-popup>


      </l-marker>
      </v-marker-cluster>

      <!-- Clicked Positions -->
      <l-marker v-if="clickedPosition" :lat-lng="clickedPosition.latlng" :icon="icon"></l-marker>
    </l-map>
  </div>
</template>

<script>
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import {latLng, icon,DivIcon,Point } from "leaflet"; //latLngBounds
import { LMap, LControlLayers,LTileLayer, LMarker,LPopup } from "vue2-leaflet"; 
//import {helper} from '@/mixins/helper.js'
//import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
//import 'leaflet-fullscreen/dist/Leaflet.fullscreen';

export default {
  name: "RTMap",
  //mixins:[helper],
  components: {
    LMap,
    LControlLayers,
    LTileLayer,
    LMarker,
    LPopup,
    'v-marker-cluster': Vue2LeafletMarkerCluster
  },
  props:{
    show:{
      type:Boolean,
      default:true
    },
    enableInput:{
      type:Boolean,
      default:false
    },
    showLayerSelector:{
      type:Boolean,
      default:true
    },
    showZoom:{
      type:Boolean,
      default:true
    },
    inputLocation:{
      type:Object
    },
    items:{
      type:Array
    },
    height:{
      type:String,
      default:"200px"
    },
    width:{
      type:String,
      default:"100%"
    },
    maxWidth:{
      type:String,
      default:"100%"
    },
    initialZoom:{
      type:Number,
      default:18
    },
    maxMapZoom:{
      type:Number,
      default:18
    },
    minMapZoom:{
      type:Number,
      default:1
    },
    singleMarkerMode:{
      type:Boolean,
      default:false
    },
    maxBoundEnabled:{
      type:Boolean,
      default:true
    },
    show_more_link:{
      type:Boolean,
      default:true
    },
    draggable:{
      type:Boolean,
      default:false
    },
  },
  watch:{
  /* Init data on creation and on update */
      items: {
        handler(val) {
          if(null!=val){
            this.initData();
          }
        },
        deep:true,
        immediate: true
      },
      inputLocation: {
        handler(val) {
          if(null!=val){
            this.initData();
          }
        },
        deep:true,
        immediate: true
      }
  },
  data() {
    return {
      clickedMarkerIndex:null,
      baseImageUrl:'https://maphub.net/media/images/',
      apiKeyHere:'',
      apiKeyLocationIq:'',
      useHereMaps:false,
      stadiaTiles:true,
      invalidateCounter:0,
      initialEndZoom:17,
      zoom: this.initialZoom,
      center: latLng(20, 0),
      attribution:'',//'&copy; <a target="_blank" href="https://stadiamaps.com">Stadia Maps</a>',
      currentZoom: 11.5,
      currentCenter: latLng(20, 0),
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl:this.showZoom,
        maxZoom: this.maxMapZoom,
        minZoom:this.minMapZoom,
        dragging: (this.draggable || !window.L.Browser.mobile)
      },
      icon: icon({
        iconUrl: "/img/map/heart.png",
        iconSize: [32, 32],
        iconAnchor: [16, 32]
      }),
      iconVideo: icon({
        iconUrl: "/img/map/video.png",
        iconSize: [32, 32],
        iconAnchor: [16, 32]
      }),
      maxBounds: null,
      clickedPosition:null,
      mapIsLoading:false,
      lastGeocodedAddress:''
    };
  },
  computed:{
    popupStyle(){
      return {
        'max-height':(this.isSmAndUpDevice)?'420px':'300px',
        'min-width':'300px',
        'overflow':'auto',
        'padding-right':'10px'
      }
    },
    isSmAndUpDevice(){
      return this.$vuetify.breakpoint.smAndUp;
    },
    tileLayers(){
      return [
        {
          name: 'Satellit',
          visible: this.showLayerSelector,
          format: 'image/png',
          url:this.satellitTitleUrl,
          attribution: ""
        },/*
        {
          name: 'Here',
          visible: true,
          format: 'image/png',
          url:this.hereTileUrl,
          attribution: ""
        },*/
        {
          name: 'Light',
          visible: true,
          format: 'image/png',
          url:this.lightTitleUrl,
          attribution: ""
        }
      ]
    },
    lightTitleUrl(){
      //return `https://2.base.maps.ls.hereapi.com/maptile/2.1/maptile/newest/reduced.day/{z}/{x}/{y}/256/png8?lg=ger&apiKey=${this.apiKeyHere}`
      return (this.stadiaTiles)?'https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png':"https://{s}-tiles.locationiq.com/v2/light/r/{z}/{x}/{y}@2x.png?key="+this.apiKeyLocationIq;
    },
    satellitTitleUrl(){
      return `https://2.aerial.maps.ls.hereapi.com/maptile/2.1/maptile/newest/hybrid.day/{z}/{x}/{y}/256/png8?lg=ger&apiKey=${this.apiKeyHere}`
      //return `https://2.base.maps.ls.hereapi.com/maptile/2.1/maptile/newest/normal.day/{z}/{x}/{y}/256/png8?lg=ger&apiKey=${this.apiKeyHere}&ppi=320`
      //return 'https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png';
    },
    hereTileUrl(){

      return `https://2.aerial.maps.ls.hereapi.com/maptile/2.1/basetile/newest/satellite/{z}/{x}/{y}/512/jpg?apiKey=${this.apiKeyHere}`

      //let style="normal.day";
      //return `https://2.base.maps.ls.hereapi.com/maptile/2.1/maptile/newest/${style}/{z}/{x}/{y}/512/png8?apiKey=${this.apiKeyHere}&ppi=320`
    },
    mapStyle(){
      return `height: ${this.height}; width: ${this.width}; max-width: ${this.maxWidth};`;
    }
  },
  methods: {

    onClickMarker(index){
      this.clickedMarkerIndex=index;
    },

    geocodeUrl(address){
      return (this.useHereMaps)?`https://geocode.search.hereapi.com/v1/geocode?q=${address}&apiKey=${this.apiKeyHere}`:`https://eu1.locationiq.com/v1/search.php?q=${address}&format=json&key=${this.apiKeyLocationIq}`
    },

    handleHereMapsGeocodeResponse(response){
      //Set pin to geocoded location
      if(response && response.data && this._.isArray(response.data.items) && response.data.items.length>0){
        let firstItem=this._.first(response.data.items);
        if(firstItem && firstItem.position){
          this.setClickedPositionByLatLng(firstItem.position.lat,firstItem.position.lng,true);
        }
      }
    },
    handleMapsGeocodeResponse(response){
      //Set pin to geocoded location

      if(response && this._.isArray(response.data) && response.data.length>0){
        let firstItem=this._.first(response.data);
        if(firstItem){
          this.setClickedPositionByLatLng(firstItem.lat,firstItem.lon,true);
        }
      }
    },

    geocodeAddress(address){
      return new Promise((resolve, reject) => {
          if(address){
            if(this.lastGeocodedAddress!=address){
            this.lastGeocodedAddress=address;
            this.mapIsLoading=true;
            this.axios.get(this.geocodeUrl(address), {params: {},withCredentials: false})
              .then((response)=>{
                console.log('Geocode success');
                if(this.useHereMaps){
                  this.handleHereMapsGeocodeResponse(response);
                }else{
                  this.handleMapsGeocodeResponse(response);
                }
                resolve();
              })
              .catch( (error) =>{
                console.log('Geocode error');
                console.warn(error);
                reject();
              }).finally(()=>{
                setTimeout(()=>{
                  this.mapIsLoading=false;
                },1000);
              })
            }else{
              resolve();
            }
          }else{
            reject();
          }
        });
    },
     
    clusterImg(cluster) {
      let childCount = cluster.getChildCount();

      var c = ' marker-cluster-';
      if (childCount < 10) {
        c += 'small';
      } else if (childCount < 100) {
        c += 'medium';
      } else {
        c += 'large';
      }

      return new DivIcon({ html: '<div class="customClusterMarker"><span>' + childCount + '</span></div>', className: 'marker-cluster' + c, iconSize: new Point(40, 40) });
    },
    addMarker(e) {
      if(this.enableInput && e && e.latlng){
        this.setClickedPositionByLatLng(e.latlng.lat,e.latlng.lng);
      }
    },
    setClickedPositionByLatLng(lat,lng,centerPositionOnMap){
      this.clickedPosition={latlng: latLng(lat,lng)}; 
      this.$emit('updatePosition',this.clickedPosition.latlng);
      if(centerPositionOnMap && this.$refs && this.$refs.map){
        this.$refs.map.setZoom(this.initialEndZoom)
        this.$refs.map.setCenter([lat, lng])
        //this.$refs.map.setView(latLng(lat,lng), this.initialEndZoom);
      }
    },
    getIconByItem(item){
      return (item && item.properties && item.properties["marker-symbol"]=="cinema")?this.iconVideo:this.icon;
    },
    getPosByItem(item){
      if(item && item.geometry && this._.isArray(item.geometry.coordinates) && !isNaN(item.geometry.coordinates[0]) && !isNaN(item.geometry.coordinates[1])){
        return latLng(Number(item.geometry.coordinates[1]),Number(item.geometry.coordinates[0]))
      }else{
        console.log('Location without position');
        console.log(item);
      }
      return latLng(0,0);
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    openLocation(item) {
      if(item && item.properties && item.properties.url){
        window.open(this.getValidUrl(item.properties.url), '_blank');
        return false;
      }
    },
    getValidUrl(url = ""){
      let newUrl = window.decodeURIComponent(url);
      newUrl = newUrl.trim().replace(/\s/g, "");

      if(/^(:\/\/)/.test(newUrl)){
          return `http${newUrl}`;
      }
      if(!/^(f|ht)tps?:\/\//i.test(newUrl)){
          return `http://${newUrl}`;
      }

      return newUrl;
  },
    
    getMap(){
      return (this.$refs.map)?this.$refs.map.mapObject:null;
    },
    closeFullScreenMap(){
      const map=this.getMap();
      if(map && map.isFullscreen()){
        map._setFullscreen(false);
        //this.invalidateCounter++;
        //map.toggleFullScreen();
      }
    },
    addFullscreenPlugin(){
      const map=this.getMap();
      if(map){
          map.addControl(new window.L.Control.Fullscreen());
          map.on('fullscreenchange', function () {
          if (map.isFullscreen()) {
              console.log('entered fullscreen');
          } else {
              console.log('exited fullscreen');
          }
        });
      }
    },
    locationIsValid(loc){
      return (loc && loc.position && loc.position.latitude && loc.position.longitude);
    },
    initData(){
      if(this.items && this.items.length==1){
        if(this.locationIsValid(this.items[0])){
            let lat=this.items[0].position.latitude;
            let lng=this.items[0].position.longitude;
            this.center=latLng(lat,lng);
        }
      }

      if(this.inputLocation){
        if(this.locationIsValid(this.inputLocation)){
          this.setClickedPositionByLatLng(this.inputLocation.position.latitude,this.inputLocation.position.longitude,true);
        }else{
          console.warn('Invalid input position');
          console.log(this.inputLocation);
        }
      }
    },
    ki(e, t, r, n) {
        let i, o;
        return r / n > e / t ? o = (i = Math.min(r, e)) * n / r : i = (o = Math.min(n, t)) * r / n,
        {
            w: i,
            h: o,
            aspect: i / o
        }
    },

    getImageUrl(e,t,r){ //item,bild.weite,bild.höhe
      let Xt = [{
          w: 544,
          h: 400
      }, {
          w: 768,
          h: 576
      }, {
          w: 1024,
          h: 768
      }, {
          w: 1344,
          h: 1008
      }, {
          w: 1856,
          h: 1392
      }];
        if (!e.image)
            return "";
        for (var n, i = this.ki(t, r, e.image.w, e.image.h), o = 1.6 * i.w, a = 1.6 * i.h, s = [Xt[0]], l = 1; l < Xt.length; l++) {
            var u = Xt[l - 1]
              , c = Xt[l];
            (e.image.w > u.w || e.image.h > u.h) && s.push(c)
        }
        for (var p = 0, f = s; p < f.length; p++) {
            var h = f[p];
            if (n = h,
            o <= h.w && a <= h.h)
                break
        }
        let d = "".concat(n.w, "_").concat(n.h);
        let idFirst=String(e.image.id).substring(0,1);
        let idSecond=String(e.image.id).substring(1,3);
        return "".concat(this.baseImageUrl).concat(idFirst,"/").concat(idSecond,"/").concat(e.image.id, "/").concat(d, ".jpg")
    }
  },
  mounted(){

    this.initData();

    //this.addFullscreenPlugin();

    /*setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 250);*/
    //setTimeout(()=>{this.mapComponentKey++}, 500);
  },
  
};
</script>

<style>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

.marker-cluster-small,.marker-cluster-small div,.marker-cluster-medium,.marker-cluster-medium div,.marker-cluster-large,.marker-cluster-large div{
    background-color: rgba(0,0,0,0)!important;
    color:white!important;
}

.leaflet-marker-icon{
    background-image: url("/img/map/heart.png")!important;
    background-size: contain;
    background-repeat: no-repeat;
}
.leaflet-marker-icon[src*="video"] {
    background-image:none!important;
}


.leaflet-control-layers.leaflet-control{
  text-align: left!important;
}
/*
.vue2leaflet-map{
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
*/
</style>